import React from "react";

function Loader() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#0f0f1a",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        animation: "fadeOut 1s ease forwards",
        animationDelay: "2s"
      }}
    >
      <h1
        style={{
          fontSize: "48px",
          color: "#00ffcc",
          letterSpacing: "3px",
          animation: "pulse 1.5s infinite"
        }}
      >
        GamePulse HQ
      </h1>
    </div>
  );
}

export default Loader;